const components = {
  MuiButton: {
    styleOverrides: {
      root: {
        boxShadow: 'none',
      },
    },
  },
  MuiCard: {
    styleOverrides: {
      root: {
        borderRadius: '8px',
        padding: '16px',
        boxShadow: 'none',
      },
    },
  },
  MuiAlert: {
    styleOverrides: {
      root: ({ theme }: any) => {
        const customColors = {
          info: {
            color: '#6B6B1A',
            border: '1px solid #B9B922',
            bgcolor: '#FFFF001A',
            iconColor: '#6B6B1A',
          },
          blue: {
            color: '#003E63',
            border: 'none',
            bgcolor: '#E6EEF4',
            iconColor: '#00598E',
          },
          success: {
            color: '#028B3D',
            border: '1px solid #08C15B',
            bgcolor: '#E6F8EF',
            iconColor: '#028B3D',
          },
          error: {
            color: '#991B1B',
            border: '1px solid #EF4444',
            bgcolor: '#EF44441A',
            iconColor: '#991B1B',
          },
          warning: {
            color: '#854D0E',
            border: '1px solid #F59E0B',
            bgcolor: '#FEF3C7',
            iconColor: '#F59E0B',
          }
        };

        return {
          borderRadius: '8px',
          fontWeight: 500,
          '&.MuiAlert-standardSuccess': {
            ...customColors.success,
            '& .MuiAlert-icon': {
              color: customColors.success.iconColor,
            },
          },
          '&.MuiAlert-standardError': {
            ...customColors.error,
            '& .MuiAlert-icon': {
              color: customColors.error.iconColor,
            },
          },
          '&.MuiAlert-standardWarning': {
            ...customColors.warning,
            '& .MuiAlert-icon': {
              color: customColors.warning.iconColor,
            },
          },
          '&.MuiAlert-standardInfo': {
            ...customColors.info,
            '& .MuiAlert-icon': {
              color: customColors.info.iconColor,
            },
          },
        };
      },
    },
  },
}

export default components
